var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolyBg1B(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 600 600",
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333 305L338 309L362 292Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 337L384 309L362 292Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 292L312 267L333 305Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 359L353 340L338 309Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338 309L370 337L362 292Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 340L370 337L338 309Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 229L357 242L362 292Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 292L357 242L312 267Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 340L367 358L370 337Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 337L397 346L384 309Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 316L321 359L333 305Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 305L321 359L338 309Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 340L321 359L367 358Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 358L388 351L370 337Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 351L397 346L370 337Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 170L272 270L312 267Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 267L264 316L333 305Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 235L362 292L384 309Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 235L389 229L362 292Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357 242L330 189L312 267Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 270L264 316L312 267Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 224L390 213L389 229Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 229L390 213L357 242Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 270L254 309L264 316Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 368L316 386L321 359Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 274L419 235L384 309Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 368L321 359L264 316Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 359L316 386L367 358Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414 411L430 388L388 351Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 235L419 224L389 229Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 146L373 195L437 154Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 213L373 195L357 242Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 195L330 189L357 242Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 195L341 180L330 189Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 358L257 368L264 316Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397 346L460 274L384 309Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 235L460 228L419 224Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 237L229 286L272 270Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 270L229 286L254 309Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 309L231 358L264 316Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 180L333 171L330 189Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 173L218 237L272 270Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 138L333 171L341 180Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 351L430 388L397 346Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397 346L480 322L460 274Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414 411L388 351L367 358Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 286L231 358L254 309Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469 246L460 228L419 235Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 154L373 195L390 213Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 195L387 146L341 180Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 274L469 246L419 235Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 272L469 246L460 274Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374 427L414 411L367 358Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 447L374 427L316 386Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316 386L374 427L367 358Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 427L316 386L264 418Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 302L480 322L532 319Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 388L480 322L397 346Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 170L312 267L330 189Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 286L181 307L231 358Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 171L277 170L330 189Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 237L206 265L229 286Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 379L229 379L231 358Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 358L229 379L257 368Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493 289L489 272L460 274Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469 246L484 224L460 228Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 418L316 386L257 368Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 322L493 289L460 274Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 379L264 418L257 368Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 302L495 285L493 289Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493 289L495 285L489 272Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 170L256 173L272 270Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 451L341 447L316 386Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374 427L392 452L414 411Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 154L390 213L419 224Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 171L293 148L277 170Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 170L248 147L256 173Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497 381L480 322L430 388Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 322L500 302L493 289Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 272L484 224L469 246Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 228L469 190L419 224Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528 261L484 224L489 272Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528 261L489 272L495 285Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 86L293 148L333 171Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375 118L380 138L381 108Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 146L380 138L341 180Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484 224L469 190L460 228Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 427L303 451L316 386Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 455L303 451L282 427Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402 458L392 452L345 487Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 447L392 452L374 427Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497 394L497 381L430 388Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 240L181 307L206 265Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 265L181 307L229 286Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469 190L437 154L419 224Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 379L237 424L264 418Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 418L290 455L282 427Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 432L237 424L229 379Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 424L290 455L264 418Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 451L345 487L341 447Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 215L182 240L218 237Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 237L182 240L206 265Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345 487L392 452L341 447Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 452L409 457L414 411Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497 394L430 388L482 425Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402 458L409 457L392 452Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 148L248 147L277 170Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 173L192 199L218 237Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 89L248 147L293 148Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 108L380 138L387 146Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 138L375 118L333 171Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 180L192 199L256 173Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 424L221 457L290 455Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 427L228 432L229 379Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482 425L430 388L454 451Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 319L528 261L500 302Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 199L181 215L218 237Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 342L160 345L181 307Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 319L480 322L530 344Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 302L528 261L495 285Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484 224L518 170L469 190Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 344L480 322L497 381Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 451L430 388L414 411Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 154L381 108L387 146Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375 118L347 86L333 171Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 345L231 358L181 307Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 345L175 379L231 358Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481 461L454 451L464 512Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409 457L454 451L414 411Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 375L530 344L497 381Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 375L497 381L515 398Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 342L181 307L120 270Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 495L303 451L290 455Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 495L345 487L303 451Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402 458L424 500L409 457Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 398L502 408L528 402Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482 425L502 408L497 394Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 270L181 307L182 240Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 345L153 360L175 379Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 199L168 210L181 215Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 215L168 210L182 240Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 180L168 210L192 199Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 147L185 180L256 173Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409 52L376 99L381 108Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 108L376 99L375 118Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 398L497 381L497 394Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528 402L502 408L481 461Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 408L515 398L497 394Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528 261L533 224L484 224Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469 190L469 122L437 154Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 154L469 122L381 108Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569 224L533 224L528 261Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 342L153 360L160 345Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 450L213 449L228 432Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 362L153 360L157 342Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 399L229 379L175 379Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 432L221 457L237 424Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 449L221 457L228 432Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 496L300 495L290 455Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153 360L167 399L175 379Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376 99L347 86L375 118Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 147L212 133L185 180Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 449L207 450L221 457Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 427L207 450L228 432Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 89L212 133L248 147Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481 461L502 408L482 425Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 398L528 402L527 375Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 335L532 319L530 344Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 280L528 261L532 319Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 170L469 122L469 190Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409 52L330 45L347 86Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533 224L518 170L484 224Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 449L177 427L106 441Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 399L177 427L229 379Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424 500L454 451L409 457Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 451L481 461L482 425Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345 487L424 500L402 458Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 516L424 500L345 487Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223 494L221 457L207 450Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223 494L253 496L221 457Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221 457L253 496L290 455Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 549L423 516L385 600Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 86L256 89L293 148Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 215L182 240L168 210Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 215L120 270L182 240Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 441L177 427L167 399Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 208L168 210L148 163Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 125L185 180L212 133Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 163L168 210L185 180Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 73L189 125L212 133Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 208L129 215L168 210Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 362L167 399L153 360Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 427L173 449L207 450Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526 145L513 133L518 170Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 170L513 133L469 122Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409 52L347 86L376 99Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 180L526 145L518 170Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 280L532 319L600 335Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 280L569 224L528 261Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533 224L569 224L518 170Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 449L223 494L207 450Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 516L345 487L354 583Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424 500L464 512L454 451Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 557L300 495L253 496Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537 126L500 117L513 133Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 133L500 117L469 122Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 137L148 163L185 180Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 208L106 215L129 215Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 89L239 77L212 133Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 125L151 137L185 180Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 48L239 77L256 89Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 516L464 512L424 500Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481 461L533 500L528 402Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446 65L381 108L469 122Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 86L270 48L256 89Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 61L151 137L189 125Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 209L106 215L132 208Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 117L446 65L469 122Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446 65L409 52L381 108Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238 56L227 73L239 77Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239 77L227 73L212 133Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 215L96 231L120 270Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 163L132 208L148 163Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 335L530 344L600 359Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607 153L537 126L526 145Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 344L527 375L600 359Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 184L518 170L569 224Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526 145L537 126L513 133Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473 0L464 4L479 0Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 160L127 163L148 163Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 137L127 160L148 163Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 163L103 209L132 208Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 231L89 289L120 270Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 270L89 289L157 342Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 174L103 209L127 163Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 215L96 231L129 215Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 209L96 231L106 215Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 359L527 375L600 390Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 519L225 522L223 494Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223 494L225 522L253 496Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 45L270 48L347 86Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 48L238 56L239 77Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 73L215 48L189 125Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 390L527 375L528 402Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 280L600 219L569 224Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 512L512 501L481 461Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 219L598 207L569 224Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 231L77 296L89 289Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 289L78 323L157 342Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 296L78 323L89 289Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 449L195 519L223 494Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 323L85 362L157 342Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 479L195 519L173 449Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 404L600 390L528 402Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 512L505 584L512 501Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 516L447 549L464 512Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354 583L345 487L300 495Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 557L253 496L225 522Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 45L279 28L270 48Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 48L241 0L238 56Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338 0L279 28L330 45Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 551L259 557L225 522Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 473L600 404L528 402Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 219L600 184L598 207Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598 207L600 184L569 224Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533 508L533 500L512 501Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 501L533 500L481 461Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 0L215 48L238 56Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238 56L215 48L227 73Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 102L89 174L127 160Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 184L600 180L518 170Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 362L106 441L167 399Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 160L89 174L127 163Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 209L72 191L96 231Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 268L0 275L77 296Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 102L127 160L151 137Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 584L533 508L512 501Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533 500L575 476L528 402Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 578L354 583L300 495Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 597L210 551L168 600Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 519L210 551L225 522Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 557L280 578L300 495Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446 65L433 17L409 52Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 0L338 0L330 45Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436 0L433 17L464 4Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 17L446 65L464 4Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261 600L280 578L259 557Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 174L72 191L103 209Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 296L53 327L78 323Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533 508L575 476L533 500Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 0L330 45L409 52Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 28L241 0L270 48Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 323L53 327L85 362Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 362L63 381L106 441Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 275L53 327L77 296Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 489L580 473L575 476Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575 476L580 473L528 402Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 0L370 0L409 52Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 -1L371 0L409 52Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 327L63 381L85 362Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 184L607 153L600 180Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 180L607 153L526 145Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 219L607 153L600 184Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 280L607 153L600 219Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 600L607 153L600 280Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 600L600 280L600 335Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616 540L600 335L600 359Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616 540L600 359L600 390Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 17L387 -1L409 52Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 0L428 -30L370 0Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 0L428 -30L338 0Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 466L102 479L106 441Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 441L102 479L173 449Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 578L353 600L354 583Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354 583L385 600L423 516Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 549L505 584L464 512Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428 -30L262 0L338 0Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338 0L262 0L279 28Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 48L126 61L189 125Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 174L29 150L72 191Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607 153L600 124L537 126Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 17L436 0L387 -1Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446 65L479 0L464 4Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 600L385 600L354 583Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428 -30L241 0L262 0Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 0L241 0L279 28Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 381L63 428L106 441Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 427L63 428L63 381Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 33L500 117L537 126Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 600L431 598L447 549Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533 508L600 489L575 476Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 600L425 600L447 549Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 124L592 96L537 126Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239 600L261 600L259 557Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 578L259 626L353 600Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239 600L259 557L210 551Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 473L600 489L600 404Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 404L616 540L600 390Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616 540L600 489L533 508Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 15L126 61L215 48Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 0L446 65L540 33Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 4L428 -30L436 0Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436 0L428 -30L387 -1Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 466L91 504L102 479Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 380L53 427L63 381Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 0L200 7L215 48Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 33L446 65L500 117Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473 0L428 -30L464 4Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 600L451 600L431 598Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431 598L451 600L447 549Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 599L239 600L210 551Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592 96L540 33L537 126Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 466L106 441L63 428Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 479L105 537L195 519Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 600L505 584L447 549Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 597L216 599L210 551Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 599L218 600L239 600Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 -21L188 0L241 0Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 0L188 0L200 7Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 7L145 15L215 48Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 600L210 551L195 519Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 599L204 597L218 600Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 0L428 -30L473 0Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 -1L428 -30L371 0Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 0L428 -30L479 0Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 427L57 466L63 428Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 368L19 380L53 327Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 327L19 380L63 381Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 427L25 435L57 466Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 66L64 102L151 137Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 268L77 296L0 240Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 66L151 137L126 61Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 504L105 537L102 479Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 547L105 537L91 504Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239 600L259 626L261 600Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261 600L259 626L280 578Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 600L259 626L385 600Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 600L479 615L425 600Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 600L479 615L451 600Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 600L259 626L239 600Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 600L259 626L218 600Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 31L89 66L126 61Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 -21L168 0L188 0Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 0L168 0L200 7Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 0L145 15L200 7Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 124L600 61L592 96Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592 96L600 61L540 33Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 33L532 0L479 0Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607 153L600 61L600 124Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 296L96 231L0 240Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 240L96 231L72 191Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 626L479 615L385 600Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 600L479 615L505 584Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 584L525 600L533 508Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 130L29 150L0 127Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 102L29 150L89 174Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 0L532 0L540 33Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 275L-3 317L53 327Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 181L-3 317L0 275Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 181L0 240L72 191Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 268L-16 181L0 275Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 380L25 435L53 427Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 574L98 547L91 504Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 412L25 435L19 380Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3 317L0 368L53 327Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 537L168 600L195 519Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 597L168 600L218 600Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 469L91 504L57 466Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 537L108 600L168 600Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 615L525 600L505 584Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 441L36 469L25 435Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 435L36 469L57 466Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 61L600 39L540 33Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608 -31L600 39L600 61Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 368L0 412L19 380Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 414L0 412L0 368Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 574L616 540L533 508Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 489L616 540L600 404Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 615L529 613L525 600Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 600L600 574L533 508Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 626L529 613L479 615Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 414L0 422L0 412Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 412L0 422L25 435Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 66L46 78L64 102Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 150L-16 181L72 191Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 31L46 78L89 66Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 31L126 61L106 0Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 441L-5 414L0 368Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 600L600 574L525 600Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11 156L-16 181L29 150Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 240L-16 181L0 268Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3 317L-20 441L0 368Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 0L126 61L145 15Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 130L-11 156L29 150Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 -21L106 0L168 0Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 0L106 0L145 15Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 -21L102 0L106 0Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 0L102 0L73 31Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 150L64 102L0 127Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 127L64 102L0 95Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 95L64 102L46 78Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 130L0 127L-11 156Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 574L108 600L98 547Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 547L108 600L105 537Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 600L44 615L259 626Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 574L91 504L0 534Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 441L25 435L0 422Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608 -31L600 0L600 39Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 39L600 0L540 33Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 0L608 -31L428 -30Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 181L-20 441L-3 317Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 414L-20 441L0 422Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 534L91 504L36 469Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529 613L600 600L525 600Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 574L627 600L616 540Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 87L46 78L-16 45Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 87L0 95L46 78Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 127L0 95L-11 156Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11 156L-16 45L-16 181Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 441L0 495L36 469Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 45L46 78L0 23Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 95L-16 45L-11 156Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529 613L600 607L600 600Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 600L627 600L600 574Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428 -30L85 -21L241 0Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 0L85 -21L73 31Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 607L627 600L600 600Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616 540L627 600L600 335Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607 153L608 -31L600 61Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 0L608 -31L532 0Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 600L608 -31L607 153Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13 552L0 534L0 495Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 495L0 534L36 469Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 574L56 600L108 600Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 600L44 615L168 600Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 600L56 600L64 574Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13 552L0 538L0 534Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 534L0 538L64 574Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 23L46 78L73 31Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 87L-16 45L0 95Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 181L-20 0L-20 441Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 7L0 23L73 31Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 600L44 615L56 600Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 600L44 615L108 600Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 441L-13 552L0 495Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 538L21 600L64 574Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13 552L21 600L0 538Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1 7L73 31Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 23L-20 0L-16 45Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 -21L0 0L73 31Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 7L-20 0L0 23Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13 552L0 600L21 600Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 600L0 600L44 615Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 441L-10 600L-13 552Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13 552L-10 600L0 600Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 600L-10 600L44 615Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 -21L-20 0L0 0Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L-20 0L1 7Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 45L-20 0L-16 181Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyBg1B);
export default __webpack_public_path__ + "static/media/polyBG1_b.3772597d7809dbd9b8d04cfe1cb199ef.svg";
export { ForwardRef as ReactComponent };